import { dictionaryEn } from './dictionaryEn';

export const resources = {
    en: {
        translation: dictionaryEn,
    },
};
